/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type ActivityForm_root$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type ActivityCard_root$ref: FragmentReference;
declare export opaque type ActivityCard_root$fragmentType: ActivityCard_root$ref;
export type ActivityCard_root = {|
  +viewer: ?{|
    +id: string
  |},
  +$fragmentRefs: ActivityForm_root$ref,
  +$refType: ActivityCard_root$ref,
|};
export type ActivityCard_root$data = ActivityCard_root;
export type ActivityCard_root$key = {
  +$data?: ActivityCard_root$data,
  +$fragmentRefs: ActivityCard_root$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "ActivityCard_root",
  "type": "Query",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "viewer",
      "storageKey": null,
      "args": null,
      "concreteType": "User",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "id",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "ActivityForm_root",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'b65de1325c35fca9e765c6be9182ab1c';
module.exports = node;
